import dynamic from "next/dynamic";

export const ContentListHorizontal = dynamic(() => import("./component"));
